import React, { useCallback, useMemo, useState } from 'react'
import { Popover, Row, Col, Button, notification } from 'antd'
import { handleErrorCatchLog, renderTranslation, stopPropagation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import BarcodeEditInput from './BarcodeEditInput'
import { insertBarcode, populateTableWithArticles } from '../../../Services/Kiosk/ArticleServices'
import { toggleEditTable } from '../../../Slices/Kiosk/TableOptionsSlice'
import { formatString } from '../../../Helpers/StringHelpers'
import { useAppDispatch, useAppSelector } from '../../../hooks'

function BarcodeEditPopover(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)

  const sizesAndBarcode = useMemo(() => {
    return props.publicBarcode.split('|')
  }, [props.publicBarcode])

  const barcodeSizeObj = useMemo(() => {
    const barcodes = {}
    if (sizesAndBarcode && sizesAndBarcode.length !== 0) {
      sizesAndBarcode.forEach(element => {
        const sizeAndValue = element.split(':')

        if (sizeAndValue[1]) {
          if (sizeAndValue[0] === 'NULL') {
            barcodes['' + sizeAndValue[1] + ''] = ''
          }
        }
      })
    }

    return barcodes
  }, [sizesAndBarcode])

  const barcodeValueObject = useMemo(() => {
    return {
      vaId: '' + props.vaId + '',
      sizeValues: barcodeSizeObj,
    }
  }, [props.vaId, barcodeSizeObj])

  const [barcodeValues, setBarcodeValues] = useState(barcodeValueObject)

  const sendBarcodeValues = useCallback(() => {
    insertBarcode(barcodeValues)
      .then((data: any) => {
        if (data && data.length !== 0) {
          let notificationMessage = ''

          data.forEach(element => {
            notificationMessage +=
              formatString(
                renderTranslation(language, TranslationKeys.tableBarcodeEditError),
                element.barcode,
                element.article,
                element.size,
              ) + '<br/>'
          })

          notification.open({
            description: <div dangerouslySetInnerHTML={{ __html: notificationMessage }} />,
            duration: 3,
            message: '',
          })
        }
        dispatch(populateTableWithArticles())
        dispatch(toggleEditTable())
      })
      .catch(err => {
        handleErrorCatchLog(err, 'Error on insert barcode values sendBarcodeValues')
      })
  }, [barcodeValues, dispatch, language])

  const sizeBarcodeTable = useMemo(() => {
    return (
      <div>
        <table
          className='barcode-recap-table-edit'
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <thead>
            <tr key={'barcode-recap-head-row-edit'}>
              <th className='head-size'>{renderTranslation(language, TranslationKeys.tableBarcodeRecapPopoverSize)}</th>
              <th className='head-barcode'>
                {renderTranslation(language, TranslationKeys.tableBarcodeRecapPopoverBarcode)}
              </th>
            </tr>
          </thead>
          <tbody>
            {sizesAndBarcode.map((element, index) => {
              const sizeAndValue = element.split(':')

              return sizeAndValue[0] && sizeAndValue[1] ? (
                <tr key={index}>
                  <td className='body-size'>{sizeAndValue[1]}</td>
                  <td
                    className={'body-barcode' + (sizeAndValue[0] !== 'NULL' ? '' : ' empty')}
                    onClick={e => {
                      e.stopPropagation()
                    }}
                  >
                    {sizeAndValue[0] !== 'NULL' ? (
                      sizeAndValue[0]
                    ) : (
                      <BarcodeEditInput
                        vaId={props.vaId}
                        size={sizeAndValue[1]}
                        setBarcodeValues={setBarcodeValues}
                        barcodes={barcodeValues}
                      />
                    )}
                  </td>
                </tr>
              ) : null
            })}
            <tr>
              <td colSpan={2}>
                <Button
                  type='primary'
                  className='btn standard-btn barcode-footer-button'
                  onClick={e => {
                    e.stopPropagation()
                    sendBarcodeValues()
                  }}
                  block
                >
                  {renderTranslation(language, TranslationKeys.tableDotsMenuEditSelection)}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }, [barcodeValues, language, props.vaId, sendBarcodeValues, sizesAndBarcode])

  return (
    <Popover id='barcode-recap-popover-edit' trigger={'click'} content={sizeBarcodeTable} placement={'left'}>
      <Row onClick={stopPropagation}>
        <Col flex='auto'>{props.children}</Col>
      </Row>
    </Popover>
  )
}

export default BarcodeEditPopover
